import React from 'react';
import {Helmet} from "react-helmet";
import Sidebar from "../Common/sidebar";
import FoodCard from "../Common/foodCard";
import API from "../../api";
import '/src/assets/css/home.css';
import '/src/assets/css/loading.css';
import {withRouter} from "react-router-dom";
import {
    BASE_URL,
    CapitalizeFirstLetter,
    capitalizeWords,
    EventEmitter,
    inverse_slugify,
    strReplace
} from "../../helper";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import ReactPaginate from 'react-paginate';
import {connect} from "react-redux";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import {images} from "../../constant";
import LoadingBar from "react-top-loading-bar";
import Promotion from "../Static/Promotion";
import ActiveFilterChip from "./ActiveFilterChip";
import CustomSelect from "../Common/CustomSelect";
const api = new API();
let timerId;

class CategoryFilter extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    static async getInitialProps({req, res, match, history, location, ...ctx}) {

        const categories = await api.getCategories({keyword: "all", category: null});
        var data = {keyword: "", categories_slug: "", restaurant_id: 2};
        const categories_slug = match.params.category_slug;
        const categories_name = match.params.category_slug;
        if (categories_slug){
            data = {keyword: "", categories_slug: categories_slug, restaurant_id: 2};
        }
        const products = await api.getFilterProduct(data);
        return {
            categories_slug : categories_slug !== undefined ? categories_slug : null,
            categories_name : categories_name !== undefined ? categories_name : null,
            categories: categories.data.response.categories,
            search_all_products: products.data.response.data,
            page_meta: products.data.response.meta,
            progress : 100,
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            filter_data: {
                keyword : null,
                range: [0, 1000],
                categories_slug: this.props.match?.params?.categories_slug,
                categories_name: this.props.match?.params?.categories_slug,
                restaurant_id: this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
                filter: {
                    is_prime: false,
                    is_bulk: false,
                    made_locally : false,
                    is_on_sell : false
                },
                lowToHigh: false,
                highToLow: false
            },
            progress : 0,
            search_keyword : null,
            seo_search: 1,
            show_loader: true,
            page_meta: null,
            loading: true,
            dropdown: false,
            products: [],
            storeItem: [],
            toggle_menu_class: "sidebar borderBoxWithRadius",
            toggle_menu_class_show: "",
            blogs : []
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleRedirection = this.handleRedirection.bind(this);
        this.topRedirection = this.topRedirection.bind(this);
        this.handleToggleOpen = this.handleToggleOpen.bind(this);
        this.handleToggleClose = this.handleToggleClose.bind(this);
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.filter_data?.restaurant_id){
            this.setState({filter_data: {...this.state.filter_data, restaurant_id: this.props.cookies.get('selected_store')}})
        }

        EventEmitter.subscribe('changeFilter', () => {
            this.changeProductFilter();
        });

        EventEmitter.subscribe('changeHeaderToggle', () => {
            this.handleToggleOpen();
        });

        EventEmitter.subscribe('changeResetFilter', () => {
            this.changeProductResetFilter();
        });

        EventEmitter.subscribe('changeFilterFromFooter', () => {
            EventEmitter.dispatch('changeResetFilter');
        });

        EventEmitter.subscribe('sidebarToggleClose', () => {
            this.setState({toggle_menu_class: "", toggle_menu_class_show: ""},()=>{
                document.getElementById("body-mob").classList.remove('fixed-position');
            });
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.cartAddedItems.cartItems && this.props.cartAddedItems.cartItems.length > 0 && this.props.cookies.get('toggle') === "") {
            const {cookies} = this.props;
            cookies.set('toggle', 'toggled');
        }
        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.filter_data?.restaurant_id){
            this.setState({filter_data: {...this.state.filter_data, restaurant_id: this.props.cookies.get('selected_store')}},()=>{
                this.getFilterProducts();
            });
        }
    }

    changeProductResetFilter() {
        const filters = localStorage.getItem("filter");
        const data = JSON.parse(filters);
        data.lowToHigh = false;
        data.highToLow = false;
        data.keyword  = null ; //this.state.filter_data?.keyword;
        data.restaurant_id = this.state.filter_data?.restaurant_id;
        this.setState({progress : 30 ,filter_data: data , search_keyword : ""}, () => {
            this.getFilterProducts();
        })
    }

    changeProductFilter() {
        const filters = localStorage.getItem("filter");
        const data = JSON.parse(filters);
        data.restaurant_id = this.state.filter_data?.restaurant_id;
        this.setState({progress : 30 ,filter_data: data}, () => {
            this.getFilterProducts();
        })
    }

    handleToggleOpen() {
        document.getElementById("body-mob").classList.add('fixed-position');
        this.setState({toggle_menu_class: "sidebar show-filter", toggle_menu_class_show: "show-drop"})
    }

    handleToggleClose() {
        document.getElementById("body-mob").classList.remove("fixed-position");
        this.setState({toggle_menu_class: "", toggle_menu_class_show: ""},()=>{
            EventEmitter.dispatch('sidebarToggleClose');
        })
    }

    handleRedirection() {
        localStorage.setItem('filter', JSON.stringify({
                range: [0, 1000],
                categories_slug: null,
                categories_name: null,
                filter: {
                    is_prime: false,
                    is_bulk: false,
                    made_locally : false,
                    is_on_sell : false
                },
            }
        ));

        this.props.history.push({
            pathname: "/"
        });
    }

    topRedirection() {
        window.scrollTo(0, 0);
    }

    handlePageChange(pageNumber) {
        this.setState({progress : 30});
        let data = this.state.filter_data;
        data.page = pageNumber.selected + 1;
        api.getFilterProduct(data).then(products => {
            this.setState({
                loading: false,
                storeItem: products.data.response.data,
                filter_data: data,
                page_meta: products.data.response.meta,
                progress : 100
            });
            window.scrollTo(0, 0);
        });
    }

    getFilterProducts() {

        clearTimeout(timerId);

        timerId = setTimeout(
            function () {
                const data = this.state.filter_data;
                data.categories_slug = this.state.filter_data?.categories_slug ? this.state.filter_data?.categories_slug :  this.props.categories_slug;
                api.getFilterProduct(data).then(products => {
                    this.setState({
                        loading: false,
                        storeItem: products.data.response.data,
                        filter_data: data,
                        page_meta: products.data.response.meta,
                        seo_search: 0,
                        progress : 100
                    });
                });
                window.scrollTo(0, 0);

            }.bind(this),
            100
        );
    }

    sortingWithPrice(e) {

        this.setState({progress : 30 });

        const data = this.state.filter_data;

        if (e.target.value === "0") {
            data.lowToHigh = false;
            data.highToLow = false;
        }

        if (e.target.value === "2") {
            data.lowToHigh = true;
            data.highToLow = false;
        }

        if (e.target.value === "1") {
            data.lowToHigh = false;
            data.highToLow = true;
        }

        this.setState({
            ...this.state.filter_data,
            filter_data: data
        }, () => {
            this.getFilterProducts();
        });
    }

    handleClear() {
        const data = this.state.filter_data;
        data.lowToHigh = false;
        data.highToLow = false;
        this.setState({
            ...this.state.filter_data,
            filter_data: data
        }, () => {
            this.getFilterProducts();
        });
    }

    getSortByValue() {
        if (this.state.filter_data?.lowToHigh === true) {
            return "2";
        }

        if (this.state.filter_data?.highToLow === true) {
            return "1";
        }

        return "0";
    }

    renderActiveFilterChips() {
        const {filter_data} = this.state;
        const range = filter_data?.range || [0, 1000];

        return (
            <>
                {(range[0] !== 0 || range[1] !== 1000) &&
                <ActiveFilterChip
                    label={`Price range: $${range[0]} - $${range[1]}`}
                    onRemove={() => {
                        EventEmitter.dispatch('changeRangeResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.is_prime === true &&
                <ActiveFilterChip
                    label="Prime items"
                    onRemove={() => {
                        EventEmitter.dispatch('changePrimeResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.is_bulk === true &&
                <ActiveFilterChip
                    label="Bulk items"
                    onRemove={() => {
                        EventEmitter.dispatch('changeBulkResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.made_locally === true &&
                <ActiveFilterChip
                    label="Local items"
                    onRemove={() => {
                        EventEmitter.dispatch('changeLocalResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.ebt_enabled === true &&
                <ActiveFilterChip
                    label="SNAP EBT Eligible"
                    onRemove={() => {
                        EventEmitter.dispatch('changeEBTResetFilter');
                    }}
                />
                }
            </>
        );
    }


    render() {

        var page_count = this.state.page_meta ? this.state.page_meta.last_page : this.props.page_meta.last_page;
        var progress = this.state.progress ? this.state.progress : this.props.progress;
        var filter_products = this.state.storeItem && this.state.storeItem.length ? this.state.storeItem : this.state.seo_search === 1 ? this.props.search_all_products : [];
        var categorySlug = this.state.filter_data?.categories_slug ? this.state.filter_data?.categories_slug :  this.props.categories_slug ;


        const iframe = '<iframe src="https://widget.smsinfo.io/v2/c72afe92b0f3a4a22e0716b7edffa88f" width="401" height="417" frameborder="0" /></iframe>';
        const iframe2 = '<iframe src="https://widget.smsinfo.io/v2/bfae2e398f41601265824c0b22917465" width="401" height="417" frameborder="0" /></iframe>';

        return (

            <React.Fragment>

                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston</title>
                    <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                    <meta name="robots" content="index, follow"/>
                    <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                    <meta property="og:type" content="article"/>
                    <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                    <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                    <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                    <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                    <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                    <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                    <meta property="og:image" content={images.logoImg}/>
                    <meta property="og:image:width" content="1449"/>
                    <meta property="og:image:height" content="1024"/>
                    <meta name="twitter:card" content="summary"/>
                    <meta name="twitter:creator" content="Farmerfreshmeat"/>
                    <meta name="twitter:site" content="Farmerfreshmeat"/>
                    <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                    <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                </Helmet>
                <LoadingBar progress={progress} color="blue "/>
                <div className="container-fluid mb-fix">
                    <div className="row">
                        {/* <div className="col-12 div-breadcrumb">
                            {
                                this.state.search_keyword && this.state.search_keyword !== "" && this.state.search_keyword !== null ?
                                    <div className="col-md-12 ">
                                        <div className="breadcrumb-details">
                                            <nav aria-label="breadcrumb">
                                                <ol className="breadcrumb">
                                                    <li className="breadcrumb-item">
                                                        <h3>
                                                            <span className="font-weight-normal">Search results for: </span>{" "}
                                                            { "“ " + this.state.search_keyword + " ”" }
                                                        </h3>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                    :
                                    categorySlug ?
                                        <div className="col-md-12 ">
                                            <div className="breadcrumb-details">
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb mb-0 pb-1">
                                                        <li className="breadcrumb-item"
                                                            onClick={() => this.handleRedirection()}>
                                                            <a href="javascript:void(0)">Farmer's Fresh Meat</a>
                                                        </li>
                                                        <li className="breadcrumb-item"
                                                            onClick={() => this.handleRedirection()}>
                                                            <a href="javascript:void(0)">Shop</a>
                                                        </li>
                                                        <li className="breadcrumb-item active" aria-current="page">
                                                            <a>{capitalizeWords(strReplace(categorySlug))}</a>
                                                        </li>
                                                    </ol>
                                                </nav>
                                                <h4 className={this.props?.location?.pathname?.includes("wholesale") ? "mb-1" : "mb-4 pb-1"}>{capitalizeWords(strReplace(categorySlug))}</h4>
                                                {this.props?.location?.pathname?.includes("wholesale") &&
                                                    <nav aria-label="breadcrumb" className="mb-4">
                                                        <ol className="breadcrumb mb-0 mt-0 pb-1">
                                                            <li className="breadcrumb-item">Wholesale pricing for all customers!</li>
                                                        </ol>
                                                    </nav>
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className="col-md-12">
                                            <div className="breadcrumb-details">
                                                <nav aria-label="breadcrumb">
                                                <ol className="breadcrumb mb-0 pb-1">
                                                        <li className="breadcrumb-item">Shop Fresh at</li>
                                                    </ol>
                                                </nav>
                                                <h4 className="mb-4">Houston's Best Meat Market</h4>
                                            </div>
                                        </div>
                            }
                        </div> */}

                        <Sidebar prods={this.props?.categories} categories_slug={categorySlug} showFilter={this.state.toggle_menu_class}/>

                        <div className="col-12 col-md-10 col-lg-10 col-xl-9 column">

                            {(this.state.page_meta ? this.state.page_meta.total : this.props.page_meta.total) > 0 &&
                                <div className="col-12 info-bar">
                                    <div className="row justify-content-between align-items-center">
                                        <div className="col-md-8 d-flex align-items-center">
                                            <div className="col-12 d-flex align-items-center px-0 d-sm-justify-content-center">
                                                {categorySlug ? <h4 className={this.props?.location?.pathname?.includes("wholesale") ? "categoryTitle" : "pb-1 categoryTitle"}>{capitalizeWords(strReplace(categorySlug))}</h4> : <h4 className="categoryTitle">Houston's Best Meat Market</h4>}
                                                {/* <small className="mr-2">
                                                    <span>Showing</span>{" "}
                                                    {this.state.page_meta ? this.state.page_meta.total : this.props.page_meta.total} results
                                                </small> */}
                                                <div className="d-md-flex d-none border-left pl-2 active-filter-list">
                                                    {this.renderActiveFilterChips()}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 d-flex justify-content-md-end align-items-center mt-2 mt-md-0 d-sm-justify-content-space-between">
                                            <small className="text-muted pr-4 mr-3 border-right border-sm-none f-sm-14">
                                                <span className="d-md-inline-block d-sm-none">Showing</span>{" "}
                                                {this.state.page_meta ? this.state.page_meta.total : this.props.page_meta.total} results
                                            </small>
                                            <div class="d-flex align-items-center">
                                                <btn className="btn-order btn-filter mobileFilterOption" onClick={() => {
                                                        EventEmitter.dispatch('toggleFromFilter');
                                                        this.handleToggleOpen()
                                                    }}>
                                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                        className="css-i6dzq1">
                                                        <line x1="4" y1="21" x2="4" y2="14"></line>
                                                        <line x1="4" y1="10" x2="4" y2="3"></line>
                                                        <line x1="12" y1="21" x2="12" y2="12"></line>
                                                        <line x1="12" y1="8" x2="12" y2="3"></line>
                                                        <line x1="20" y1="21" x2="20" y2="16"></line>
                                                        <line x1="20" y1="12" x2="20" y2="3"></line>
                                                        <line x1="1" y1="14" x2="7" y2="14"></line>
                                                        <line x1="9" y1="8" x2="15" y2="8"></line>
                                                        <line x1="17" y1="16" x2="23" y2="16"></line>
                                                    </svg>
                                                    Filter
                                                </btn>
                                                <span className="mr-2 d-sm-none"> Sort by</span>
                                                <CustomSelect
                                                    ariaLabel="Sort products"
                                                    className="sortDropdown"
                                                    name="sortBy"
                                                    value={this.getSortByValue()}
                                                    options={[
                                                        {value: "0", label: "Best match"},
                                                        {value: "2", label: "Price low to high"},
                                                        {value: "1", label: "Price high to low"},
                                                    ]}
                                                    onChange={(e) => this.sortingWithPrice(e)}
                                                />
                                            </div>
                                        </div>

                                        {this.props.location.pathname.startsWith("/category") &&
                                        <malignmark className={this.state.toggle_menu_class_show}>
                                            <button className="btn-close" onClick={() => {
                                                this.handleToggleClose()
                                            }}></button>
                                        </malignmark>
                                        }
                                    </div>
                                </div>
                            }

                            <div className="col-12 filter-div">
                                <div className="col-12 filter-content">
                                    {this.renderActiveFilterChips()}
                                </div>
                            </div>
                            <div className="row display-details">
                                {!!filter_products.length && filter_products.map((item) => {
                                            if(item.variables.length > 0) {
                                                return <FoodCard key={item.id} val={item}/>
                                            }
                                        })
                                }
                            </div>
                            {
                                this.props?.categories_slug === "weekly-sale" &&
                                <div className={filter_products.length > 0 ? "promo-export pt-5" : "promo-export pt-3"}>
                                    <Promotion home={true} slider={filter_products.length > 0 ? true : false} />
                                </div>
                            }
                            { filter_products.length < 1 && this.props?.categories_slug !== "weekly-sale" &&
                            <>
                                <div className="py-3 blank-banner">
                                    <img src={images.order_food}/>
                                    <h2 className="mt-3 mb-1">Item not found</h2>
                                    <p className="mt-1 mb-3">
                                        {
                                            this.state.search_keyword !== null && this.state.search_keyword !== "" && this.state.filter_data?.categories_name ?
                                                <>
                                                    <span>We couldn’t find any items named “ {this.state.search_keyword}. ”</span>
                                                    <span>Please try a different keyword or select a product category from our menu.</span>
                                                </>
                                                :
                                                this.state.search_keyword !== null && this.state.search_keyword !== "" ?
                                                    <>
                                                        <span>We couldn’t find any items named “ {this.state.search_keyword} "</span>
                                                        <span>Please try a different keyword or select a product category from our menu.</span>
                                                    </>
                                                    :
                                                    this.state.filter_data?.categories_name ?
                                                        <>
                                                            <span>We couldn’t find any items. Please try a different product category from our menu.</span>
                                                        </>
                                                        : ""
                                        }
                                    </p>
                                    <button onClick={() => {this.handleRedirection()}} className="mx-auto btn btn-m btn-info w-auto px-3">
                                        View all items
                                    </button>
                                </div>
                            </>
                            }
                            {page_count > 1 ?
                                <div className="pagination">
                                    <ReactPaginate
                                        previousLabel={<i className="fas fa-chevron-left"></i>}
                                        nextLabel={<i class="fas fa-chevron-right"></i>}
                                        pageCount={page_count}
                                        onPageChange={this.handlePageChange.bind(this)}
                                        marginPagesDisplayed={0}
                                        pageRangeDisplayed={5}
                                        containerClassName={'paginationBttns'}
                                        previousLinkClassName={'previousBttn'}
                                        nextLinkClassName={'nextBttn'}
                                        disabledClassName={'paginationDisabled'}
                                        activeClassName={'paginationActive'}
                                    />
                                </div>
                                : ""}
                        </div>
                    </div>
                    <btn className="btn-order btn-float" onClick={() => {
                        this.topRedirection()
                    }}>
                        <i className="fas fa-chevron-up"></i>
                    </btn>
                </div>

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        cartAddedItems: state.CartReducer.cartItems,
    };
};

export default withRouter(withCookies(connect(mapStateToProps, null)(CategoryFilter)))
